import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetLoggedUserData() {

    var url = "/get_logged_user";

    return FetchGetDataWithAuthNEW(url);
}

